import { render, staticRenderFns } from "./WWWConfig.vue?vue&type=template&id=0a577a4b"
import script from "./WWWConfig.vue?vue&type=script&lang=ts"
export * from "./WWWConfig.vue?vue&type=script&lang=ts"
import style0 from "./WWWConfig.vue?vue&type=style&index=0&id=0a577a4b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports